import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents } from 'presto-mini-apps-lib';
import { defaultOverlayStyle, ButtonHeight } from '../../constants/appState';
import { appService } from '../../services';
import {
    term_loyaltyButtonConfirm,
    term_loyaltyOtp,
    phrase_OTPTimer,
    term_getOTP,
    phrase_LoyaltyInputOtp,
    phrase_LoyaltyOtpErrorMessage,
    term_resendOTP,
} from '../../constants/text';
import DigitInputWithLabel from '../DigitInputWithLabel';
import { ErrorCode } from '../../constants/statusCode';

class LoyaltyTypeOtpModal extends Component {
    constructor(props) {
        super(props);

        this.smsOtpInput = null;
        this.tickCount = 0;

        this.state = {
            inputError: false,
            submitDisabled: true,
            countryCodeList: [],
            formValue: {
                inputOtp: '',
            },
            otp: {
                timerID: null,
                lifeSpan: null,
                started: false,
                ended: true,
                secondsLeft: 0,
            },
        };
    }

    componentWillUnmount() {
        clearInterval(this.state.otp.timerID);
        this.tickCount = 0;
    }

    componentDidMount() {
        appService.apiGetCountryCode({
            onSuccess: (data) => {
                const countryCodeList = [];
                data.map(item => {
                    const countryCode = { 
                        code: item.mobileCountryCode, 
                        imageUrl: item.imageUrl
                    };
                    countryCodeList.push(countryCode);
                });

                this.setState({ countryCodeList: countryCodeList });
            },
            onError: (error) => {
                console.log('Error getting Country Code:', error);
            }
        });

        this.resendOTP();
    }

    componentDidUpdate(prevProps) {
        const {
            clearField,
        } = this.props;

        if (prevProps.clearField !== clearField) {
            if (clearField) {
                this.setState({
                    inputError: false,
                    submitDisabled: true,
                });
            }
        }
    }

    onInputStateChangeHandler = (input, elmName) => {
        const { loyaltyItem } = this.props;

        this.setState({
            formValue: {
                ...this.state.formValue,
                inputOtp: input
            },
            submitDisabled: !(!!input && input.length === loyaltyItem.otpLength)
        });
    };

    checkForm = () => {
        const { formValue } = this.state;

        const input = formValue.inputOtp;
        if (!!input && input.length > 0) {
            this.setState({
                inputError: false,
            });
            return true;
        } else {
            this.setState({
                inputError: false,
            });
            return false;
        }
    };

    onSubmitHandler = (e) => {
        e.preventDefault();
        const res = this.checkForm();
        if (res) {
            this.doLoyaltyRevalidation();
        }
    };

    doLoyaltyRevalidation = () => {
        const { formValue } = this.state;
        const { loyaltyItem } = this.props;

        console.log("Status: Performing loyalty revalidation...");
        appService.apiLoyaltyRevalidate({
            paymentCode: window.PrestoPayObj.paymentCode,
            loyaltyType: loyaltyItem.loyaltyId,
            secret: formValue.inputOtp,
            onSuccess: this.onLoyaltyRevalidationSuccessHandler,
            onError: this.onLoyaltyRevalidationFailedHandler
        });
    };

    onLoyaltyRevalidationSuccessHandler = (resp) => {
        const { onSubmit } = this.props;

        if(!!resp.success) {
            console.log("Status: Loyalty revalidation success");

            clearInterval(this.state.otp.timerID);
            this.tickCount = 0;

            this.setState({
                inputError: false,
            });

            if (typeof onSubmit === 'function') {
                onSubmit(resp.data.loyaltyMethod);
            }
        } else {
            this.setState({
                inputError: true,
            });
        }
    };

    onLoyaltyRevalidationFailedHandler = (data) => {
        this.setState({
            inputError: true,
        });
    };

    resendOTP = () => {
        const { loyaltyItem } = this.props;

        appService.apiLoyaltyRequestOtp({
            paymentCode: window.PrestoPayObj.paymentCode,
            loyaltyType: loyaltyItem.loyaltyId,
            mobileNum: loyaltyItem.mobileNum,
            mobileCountryCode: loyaltyItem.mobileCountryCode,
            onSuccess: this.onSubmitOTPSuccessHandler,
            onError: this.onSubmitOTPFailedHandler,
        });
    };

    onSubmitOTPSuccessHandler = (resp) => {

        if(!resp.success) {
            if(+resp.errorCode === ErrorCode.MAX_OTP_RESEND_REACHED) {
                this.setState({
                    inputError: true
                });
                return;
            }
        } else {
            this.setState({
                inputError: false,
                otp: {
                    ...this.state.otp,
                    lifeSpan: +resp.data.resendPeriod,
                    secondsLeft: +resp.data.resendPeriod,
                    timerID: setInterval(() => this.otpTick(), 1000),
                    started: true,
                    ended: false
                }
            });

            if (this.smsOtpInput) {
                this.smsOtpInput.clear();
                this.smsOtpInput.focus();
            }
        }
    };

    onSubmitOTPFailedHandler = (data) => {
        console.log('onSubmitOTPFailedHandler', data);
    };

    otpTick() {
        const { otp } = this.state;

        this.tickCount++;
        let timeRemaining = (+otp.lifeSpan - this.tickCount);

        if (timeRemaining >= 0) {
            this.setState({
                otp: {
                    ...this.state.otp,
                    ended: false,
                    secondsLeft: timeRemaining
                }
            });
        } else {
            clearInterval(this.state.otp.timerID);
            this.tickCount = 0;
            this.setState({
                otp: {
                    ...this.state.otp,
                    ended: true,
                    secondsLeft: 0
                }
            });
        }
    }

    render() {
        const {
            submitDisabled,
            inputError,
            otp,
            countryCodeList,
        } = this.state;
        const {
            clearField,
            isOpen,
            onClose,
            loyaltyItem,
        } = this.props;

        const countryCode = countryCodeList.filter(item => (!!loyaltyItem && item.code === loyaltyItem.mobileCountryCode));

        return (
            <React.Fragment>
                <ModalOverlayWrapper className={[
                    'modal-overlay',
                    (!!isOpen ? ' show' : '')
                ].join('')}>
                    <div className="overlay" />
                    <ModalPanelWrapper className="popup-panel">
                        <div className="panel-control">
                            <button className="close-button" onClick={onClose} />
                        </div>
                        <div className="panel-header">
                            <div className="logo">{ !!loyaltyItem ? (loyaltyItem.logo) : '' }</div>
                        </div>
                        <div className="panel-body border-top">
                            <div className="loyalty-row padded">
                                {loyaltyItem.otpMessage}
                            </div>
                            <div className="loyalty-row">
                                <div className="account-details">
                                    {countryCode.length > 0 && (
                                        <img className="country-flag" src={countryCode[0].imageUrl} alt="Flag" />
                                    )}
                                    <div className="account-no">{!!loyaltyItem ? loyaltyItem.mobileCountryCode : ''} {!!loyaltyItem ? loyaltyItem.mobileNum : ''}</div>
                                </div>
                                <div className="otp-timer">
                                    <div className="countdown-timer">
                                        {!otp.ended
                                            ? <span className="timer-time">{phrase_OTPTimer} ({otp.secondsLeft})</span>
                                            : <span className="resend-otp" onClick={this.resendOTP}>{!!otp.started ? term_resendOTP : term_getOTP}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">
                            <div className="title">{term_loyaltyOtp}</div>
                            <div className="amount">
                                <DigitInputWithLabel
                                    ref={n => (this.smsOtpInput = n)}
                                    initialValue=""
                                    length={!!loyaltyItem ? loyaltyItem.otpLength : 0}
                                    inputName="otpNumber"
                                    type="password"
                                    onChange={this.onInputStateChangeHandler}
                                    errorMessage={phrase_LoyaltyOtpErrorMessage}
                                    isError={inputError}
                                    clearField={clearField}
                                    disabled={!!otp.ended}
                                />
                            </div>
                        </div>
                        <div className="panel-action">
                            <PrestoAppComponents.Button
                                height={ ButtonHeight + 'px' }
                                className="confirm-button"
                                disabled={ submitDisabled }
                                onClick={ this.onSubmitHandler }
                            >{term_loyaltyButtonConfirm}</PrestoAppComponents.Button>
                        </div>
                    </ModalPanelWrapper>
                </ModalOverlayWrapper>
            </React.Fragment>
        );
    }
}

export default LoyaltyTypeOtpModal;


const commonBorderRadius = 6; // 6px
const commonBoxShadow = '0 1px 4px rgba(0, 0, 0, 0.1)';

const ModalOverlayWrapper = styled.div`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 100;
    
    & .overlay {
        ${defaultOverlayStyle}
    }
    
    &.show {
        display: flex;
    }
`;

const ModalPanelWrapper = styled.div`
    position: relative;
    width: 100%;
    border-radius: ${commonBorderRadius}px;
    box-shadow: ${commonBoxShadow};
    background-color: ${PrestoAppTheme.colors.white};
    border: solid ${PrestoAppTheme.colors.white} 1pt;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    
    & .panel-control {
        padding: 0;
        box-sizing: border-box;
        flex: 1;
        
        & .close-button {
            height: 0.75em;
            width: 0.75em;
            padding: 0px;
            margin: 0px;
            background: transparent url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAGQAAAAB7O7VkAAABkElEQVRIDa2VwVGEMBSGIR6A244l2IB2IByhChvQsRVLoAJ3PHJBO3ArsAP1Bsyw4P8zGyYLCSSs78BLXpL/C8lL4nuwsix3TdPcB0HwkSTJL2OX2FRPMFBV1Vff93t4VMvdJYCiKO6kXl3Xr9QSCMS+7w/C8OywGURA27al1IN+zEmLLMv2qBxIpG0FaQAeVueFyy8oHIZhDLcZpANAL8cPPMN7Pj80/hbW8B3FW9ZpmMlnFEWYjDkZTIA0TR8GEXxGCAOuIBsAdc8gLiBbgBZiA3IBGCFLICHEU9d1b0qasnuu7gEDqs2WS2007NERgCul3yKA/RYh7KADMX6yVQD7DedEjtB5pi9m/oi246T9G+drOAeT+Ky6CuEmcw8wUl0iCl3bXkGLEF0W4YD+yKnaXkFGiA4A8Rw3wA280xWk3XgTQKapLhmWrqAZZA0gl8oFdAaxBbiCRogrwAU0QLYCbEHDGz95MjnW6iRLCA+s7uHTvvGnQU6AJRDatG/8JoAJJN942e5xX8bKPxRUvT+Ek5OUznWWswAAAABJRU5ErkJggg==") no-repeat scroll center center / contain;
            border: 0px none;
            cursor: pointer;
        }
    }

    & .panel-header {
        padding: 0.5rem 0;
        text-align: center;
        box-sizing: border-box;
        flex: 1;
        
        & .logo {
            margin: 0 auto;
            
            & img {
                width: 40%;
            }
        }
    }

    & .panel-body {
        padding: 0.5rem 0;
        text-align: left;
        box-sizing: border-box;
        flex: 3;
        font-weight: 300;
        font-size: 0.75rem;
        
        &.border-top {
            border-top: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
        }
        
        & .loyalty-row {
            display: flex;
            width: 100%;
            justify-content: space-between;
            line-height: 1.25rem;
            font-weight: 500;
            font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
        
            & .label {
            }
            
            & .value {
                font-weight: 400;
            }

            & .account-details {
                display: flex;

                & .country-flag {
                    flex-grow: 1;
                    height: 1.5rem;
                }

                & .account-no {
                    flex-grow: 2;
                    margin-left: 0.25rem;
                }
            }

            & .otp-timer {
                display: block;
                text-align: right;

                & .resend-otp {
                    color: ${PrestoAppTheme.colors.baseBlue};
                    cursor: pointer;
                }

            }
        }
        
        & .padded {
            padding-bottom: ${PrestoAppTheme.layout.smallGap};
        }
        
        & .title {
            font-weight: 500;
            font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
        }
        
        & .amount {
            
            & .error-message {
                line-height: 1.2rem;
            }
        }
    }

    & .panel-action {
        display: flex;
        padding: ${PrestoAppTheme.layout.smallGap} 0;
        text-align: right;
        box-sizing: border-box;
        justify-content: flex-end;
        flex: 1;
        bottom: 0;
        right: 0;
        opacity: 100%;
    }
`;

